import Http from "./Http";

export class CommentsService extends Http {
  /**
   * Like comment
   * @param {number} id
   */
  likeComment(id) {
    return this.post(`/comments/${id}/likes`);
  }

  /**
   * Unlike comment
   * @param {number} id
   */
  unlikeComment(id) {
    return this.delete(`/comments/${id}/likes`);
  }

  /**
   * Edit comment text content
   * @param {number} id
   * @param {Object} body
   * @param {string} body.text
   */
  editComment(id, body) {
    return this.put(`/comments/${id}`, body);
  }

  /**
   * Delete comment
   * @param {number} id
   */
  deleteComment(id) {
    return this.delete(`/comments/${id}`);
  }
}

export default new CommentsService();
